import { render, staticRenderFns } from "./SubmitForm15.vue?vue&type=template&id=20fee102&scoped=true"
import script from "./SubmitForm15.vue?vue&type=script&lang=ts"
export * from "./SubmitForm15.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fee102",
  null
  
)

export default component.exports